import { IColumn } from 'core-components/library/list/types'

export const IGNORED_FIELDS = ['EntryID']

export const COLUMNS: IColumn[] = [
  { field: 'ContactID', title: 'Contact ID', priority: 1 },
  { field: 'LearnerID', title: 'Learner ID', priority: 2 },
  { field: 'FirstName', title: 'First Name', priority: 3 },
  { field: 'LastName', title: 'Last Name', priority: 4 },
  { field: 'WorkflowStatus', title: 'Workflow status', priority: 5 },
  {
    field: 'ProfileTeamComment',
    title: 'Profile team comment',
    priority: 6,
  },
  { field: 'Market', title: 'Market', priority: 7 },
  {
    field: 'PR_HP_ROLE',
    title: 'Hp Roles',
    priority: 8,
  },
  {
    field: 'UserStatus',
    title: 'User Status',
    priority: 9,
  },
  {
    field: 'WorkPhone',
    title: 'Work Phone',
    priority: 10,
  },
  {
    field: 'MobilePhone',
    title: 'Mobile Phone',
    priority: 11,
  },
  { field: 'Email', title: 'Email', priority: 12 },
  {
    field: 'LocationID',
    title: 'Location ID',
    priority: 13,
  },
  {
    field: 'NeverCall',
    title: 'Never Call',
    priority: 14,
  },
  {
    field: 'NeverEmail',
    title: 'Never Email',
    priority: 15,
  },
  {
    field: 'PartnerID',
    title: 'Partner ID',
    priority: 16,
  },
  {
    field: 'CommunicationName',
    title: 'Comm. Name',
    priority: 17,
  },
  { field: 'City', title: 'City', priority: 18 },
  {
    field: 'PrimaryPartner',
    title: 'Primary',
    priority: 19,
  },
  {
    field: 'TopPartnerID',
    title: 'TopPartnerID',
    priority: 20,
  },
  { field: 'ModifiedBy', title: 'Modified By', priority: 21 },
  { field: 'Modified', title: 'Modified', priority: 22 },
]
